import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { FavoritesService } from "../../../../../../shared/src/lib/services/favorites.service";
import { MatIconModule } from "@angular/material/icon";
import { ModalService } from "../../../../../../shared/src/lib/services/modal.service";
import { FavouritesManagerComponent } from "../favourites-manager/favourites-manager.component";
import { RouterLink } from "@angular/router";
import { NavService } from "../../../../../../shared/src/lib/services/nav.service";
import { BreakpointObserver } from "@angular/cdk/layout";
import { MarketService } from "../../../../../../shared/src/lib/services/market.service";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { MarketOpsService } from "../../content/market-layout/market/market-ops.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-favorites",
  imports: [MatIconModule, RouterLink, MatProgressBarModule, TranslateModule],
  templateUrl: "./favorites.component.html",
  styleUrl: "./favorites.component.scss",
})
export class FavoritesComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  favoritesService = inject(FavoritesService);
  modalService = inject(ModalService);
  navService = inject(NavService);
  marketService = inject(MarketService);
  favoriteItems: any[] = [];
  modalWidth = "70%";
  loader = inject(LoaderService);
  marketOps = inject(MarketOpsService);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.setupBreakpointObserver();
  }

  ngOnInit() {
    this.getFavoriteItems();
  }

  setupBreakpointObserver() {
    this.breakpointObserver
      .observe("(max-width: 600px)")
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.modalWidth = result.matches ? "95%" : "70%";
      });
  }

  handleFavorites() {
    this.modalService.openModal({
      component: FavouritesManagerComponent,
      width: this.modalWidth,
      height: "80%",
    });
  }

  getFavoriteItems() {
    this.favoritesService
      .getFavoriteItems()
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        let marketIds: string[] = [];
        value?.forEach((event: any) => {
          if (!event?.markets?.length) return;
          marketIds = [...marketIds, ...event?.markets?.map((market: any) => `bf_${market.id}`)];
        });
        // console.log(marketIds);
        if (marketIds?.length > 0) {
          this.getMarketStatus({ market_ids: marketIds?.join(",") }, value);
        } else {
          this.favoriteItems = value;
          this.favoritesService.setLocalFavorites(this.favoriteItems);
        }
      });
  }

  getMarketStatus(params: any, favoriteEvents: any[]) {
    const qParams = { ...params, statuses: "2,3" };
    this.marketService
      .fetchMarketStatus(qParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          // console.log(response);
          const { statuses = {} } = response || {};
          // console.log(snapshots);
          // console.log(statuses);
          if (favoriteEvents?.length > 0) {
            const openedMarkets = statuses["2"] || [];
            const suspendedMarkets = statuses["3"] || [];
            // console.log(openedMarkets);
            // console.log(suspendedMarkets);
            this.favoriteItems = favoriteEvents
              .map((event: any) => {
                let eventMarkets = event?.markets;

                if (eventMarkets?.length > 0) {
                  let filteredMarkets = eventMarkets?.filter((market: any) => {
                    const _marketId = `bf_${market?.id}`;
                    return openedMarkets.includes(_marketId) || suspendedMarkets.includes(_marketId);
                  });
                  return { ...event, markets: filteredMarkets };
                }

                return { ...event };
              })
              ?.filter((event) => event?.markets?.length);
            this.favoritesService.setLocalFavorites(this.favoriteItems);
          }
        },
        error: (error) => {
          console.error("Failed to fetch market statuses:", error);
        },
      });
  }

  handleClick(item?: any) {
    if (item?.type === "MARKET") {
      this.marketOps.navMarket$.next(item?.id);
    }
    // console.log("getting clicked here boy");
    this.navService.setOpenSportsPanel(true);
    this.navService.setOpenFavoritesPanel(false);
    if (window.innerWidth < 1280) {
      this.navService.openSportsBar.next(false);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
